import { RootState } from 'redux/store'

export const formIsDirtySelector = (id: string) => (state: RootState) =>
  state.forms[id]?.isDirty
